import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PaymentState {
  amount: number;
  paymentLink: string;
}

const initialState: PaymentState = {
  amount: 0,
  paymentLink: '',
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPaymentDetails: (
      state,
      action: PayloadAction<{ amount: number; paymentLink: string }>
    ) => {
      state.amount = action.payload.amount;
      state.paymentLink = action.payload.paymentLink;
    },
    clearPaymentDetails: (state) => {
      state.amount = 0;
      state.paymentLink = '';
    },
  },
});

export const { setPaymentDetails, clearPaymentDetails } = paymentSlice.actions;

export default paymentSlice.reducer;
